export default "__VITE_ASSET__14c40687__"